export function selectBase(state) {
  return state.customerRatingSettings
}
